import React from "react"
import { Stack } from "@carrotfertility/carotene"
import { HomepageHelp } from "./components/homepage/HomepageHelp"
import { ProviderSearchForm } from "./components/homepage/ProviderSearchForm"
import { Benefit } from "./types/Benefit"

export function ProviderHomepage({ benefit }: { benefit: Benefit }): JSX.Element {
  return (
    <Stack direction="column" spacing="huge" padding="24px 0 16px 0">
      <ProviderSearchForm benefit={benefit} />
      <HomepageHelp />
    </Stack>
  )
}
